export default __webpack_public_path__ + "static/media/catMagnify.62e63c66.svg";